import {loadingDialog_show} from "../../actions";
import {getApiConfig, getMasterFabricatorId} from "../../utilities";
import {getFeaturesChangesToPost, showErrorOnSave} from "../FeaturesSetup/featuresAsyncActions";
import {AVAILABLE_VISUALIZERS} from "../../constants/dashboard";

// {"values":{"2671":{"toolSettings":"[{\"fabricatorFeature_Id\":58172772,\"tool\":\"bathroom\",\"created\":\"2023-05-26T20:32:36\",\"createdBy_id\":9,\"modified\":\"2023-05-26T20:32:36\",\"modifiedBy_id\":9,\"enableVisualizer\":false,\"enableQuotingTool\":false,\"fabricatorFeature\":null},{\"fabricatorFeature_Id\":58172772,\"tool\":\"kitchen\",\"created\":\"2023-05-26T20:37:03\",\"createdBy_id\":9,\"modified\":\"2023-05-26T20:37:03\",\"modifiedBy_id\":9,\"enableVisualizer\":true,\"enableQuotingTool\":true,\"fabricatorFeature\":null},{\"tool\":\"fireplace\",\"enableQuotingTool\":false,\"enableVisualizer\":false}]","enabled":true,"toolSettings_save":"[{\"fabricatorFeature_Id\":58172772,\"tool\":\"bathroom\",\"created\":\"2023-05-26T20:32:36\",\"createdBy_id\":9,\"modified\":\"2023-05-26T20:32:36\",\"modifiedBy_id\":9,\"enableVisualizer\":false,\"enableQuotingTool\":false,\"fabricatorFeature\":null},{\"fabricatorFeature_Id\":58172772,\"tool\":\"kitchen\",\"created\":\"2023-05-26T20:37:03\",\"createdBy_id\":9,\"modified\":\"2023-05-26T20:37:03\",\"modifiedBy_id\":9,\"enableVisualizer\":true,\"enableQuotingTool\":true,\"fabricatorFeature\":null},{\"tool\":\"fireplace\",\"enableQuotingTool\":false,\"enableVisualizer\":false}]"},"2704":{"toolSettings":"[{\"fabricatorFeature_Id\":58172767,\"tool\":\"bathroom\",\"created\":\"2023-05-26T20:32:36\",\"createdBy_id\":9,\"modified\":\"2023-05-26T20:32:36\",\"modifiedBy_id\":9,\"enableVisualizer\":false,\"enableQuotingTool\":false,\"fabricatorFeature\":null},{\"fabricatorFeature_Id\":58172767,\"tool\":\"fireplace\",\"created\":\"2024-04-17T16:39:50\",\"createdBy_id\":245077,\"modified\":\"2024-04-17T16:39:50\",\"modifiedBy_id\":245077,\"enableVisualizer\":true,\"enableQuotingTool\":true,\"fabricatorFeature\":null},{\"fabricatorFeature_Id\":58172767,\"tool\":\"kitchen\",\"created\":\"2023-05-26T20:37:03\",\"createdBy_id\":9,\"modified\":\"2023-05-26T20:37:03\",\"modifiedBy_id\":9,\"enableVisualizer\":true,\"enableQuotingTool\":true,\"fabricatorFeature\":null}]","enabled":true,"toolSettings_save":"[{\"fabricatorFeature_Id\":58172767,\"tool\":\"bathroom\",\"created\":\"2023-05-26T20:32:36\",\"createdBy_id\":9,\"modified\":\"2023-05-26T20:32:36\",\"modifiedBy_id\":9,\"enableVisualizer\":false,\"enableQuotingTool\":false,\"fabricatorFeature\":null},{\"fabricatorFeature_Id\":58172767,\"tool\":\"fireplace\",\"created\":\"2024-04-17T16:39:50\",\"createdBy_id\":245077,\"modified\":\"2024-04-17T16:39:50\",\"modifiedBy_id\":245077,\"enableVisualizer\":true,\"enableQuotingTool\":true,\"fabricatorFeature\":null},{\"fabricatorFeature_Id\":58172767,\"tool\":\"kitchen\",\"created\":\"2023-05-26T20:37:03\",\"createdBy_id\":9,\"modified\":\"2023-05-26T20:37:03\",\"modifiedBy_id\":9,\"enableVisualizer\":true,\"enableQuotingTool\":true,\"fabricatorFeature\":null}]"}}}


export const saveWizardFeaturesToolSettings = (wizardPopupState, intl) => {
  return (dispatch, getState) => {

    let visualizersToUpdate = Array.isArray(wizardPopupState.visibleInVisualizers) && wizardPopupState.visibleInVisualizers.length
      ? wizardPopupState.visibleInVisualizers
      : Object.keys(AVAILABLE_VISUALIZERS)
    if (!wizardPopupState.featuresIncluded || !wizardPopupState.featuresIncluded.length) {
      return
    }

    const {auth, asCustomer, featuresCreatorNew} = getState();
    const pendingFeatures = {};

    for (const feature of wizardPopupState.featuresIncluded) {
      visualizersToUpdate.forEach(visualizer => {
        const fullFeature = featuresCreatorNew.enabledFeatures.find(feat => {
          return feature.featureDefinitionId === feat.featureDefinitionId
        });
        if (!fullFeature) {
          return;
        }
        const toolSettings = fullFeature.toolSettings || [];
        let setting = fullFeature.toolSettings.find(setting => setting.tool === visualizer);
        if (!setting) {
          setting = {
            tool: visualizer,
            enableQuotingTool: false,
            enableVisualizer: false,
          }
          toolSettings.push(setting);
        }
        if (!setting.enableQuotingTool) {
          setting.enableQuotingTool = true;
          pendingFeatures[fullFeature.featureDefinitionId] = {
            ...pendingFeatures[fullFeature.featureDefinitionId], // just in case it was already there
            enabled: true,
            toolSettings_save: JSON.stringify(fullFeature.toolSettings)
          }
        }
      });
    }
    console.log("pendingFeatures", pendingFeatures);
    if (!Object.keys(pendingFeatures).length) {
      return
    }

    dispatch(loadingDialog_show(true, "Saving...", "Please wait while we are updating your changes."));
    // const fabricatorId =  asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;

    const featuresChanges = getFeaturesChangesToPost(pendingFeatures);
    //masterfabid set to let back-end know which fabricator to look for as the source for importing new features into the fabricator's profile.
    let masterFabId = getMasterFabricatorId(asCustomer.data ? asCustomer.data.masterFabricatorIds : auth.masterFabricatorIds);
    return getApiConfig('ProjectScope').post(featuresChanges, `feature-group-features/${masterFabId}`)
      .then((response) => {
        console.log('response save features ->', response);
        dispatch(loadingDialog_show(false));
        if ((!response && !Number.isInteger(response)) || response.error || response.__error__) { // response 0 is ok
          showErrorOnSave(dispatch, response, intl)
          return false
        }
        return response
      })
      .catch((response) => {
        console.log('error save features ->', response);
        dispatch(loadingDialog_show(false));
        showErrorOnSave(dispatch, response, intl);
        return false
      });
  }
};
